import { XrtSortExpressions } from '../xrt/xrt-sort-expressions';
import { ConditioningService } from '../../services/conditioning-service/conditioning.service';

export interface BolSearchFilter {
  bolStatusCd?: {
    equals?: string;
    startsWith?: string;
    contains?: string;
  };
  proNbr?: {
    equals?: string;
    startsWith?: string;
    contains?: string;
  };
  pkupDate?: {
    min?: string;
    max?: string;
  };
  shipperPostalCd?: {
    equals?: string;
    startsWith?: string;
    contains?: string;
  };
  consigneePostalCd?: {
    equals?: string;
    startsWith?: string;
    contains?: string;
  };
  [key: string]: any;
}

export class BolSearchRequest {
  page: number;
  sortExpressions: XrtSortExpressions[];
  filter: BolSearchFilter;

  constructor() {
    this.page = 1;
    this.sortExpressions = [];
    this.filter = {};
  }

  static fromXrtSearchRequest(xrtRequest: any): BolSearchRequest {
    const bolRequest = new BolSearchRequest();
    const conditioningService = new ConditioningService();
    bolRequest.page = xrtRequest.page || 1;
    bolRequest.sortExpressions = xrtRequest.sortExpressions || [];
    
    const filters = xrtRequest.filters || {};
    
    Object.keys(filters).forEach(key => {
      const value = filters[key];
      
      switch (key) {
        case 'bolStatusCd':
        case 'shipperPostalCd':
        case 'consigneePostalCd':
          bolRequest.filter[key] = { equals: value };
          break;
          
        case 'Q':
          const cleanValue = String(value).trim();
          if (/^\d+$/.test(cleanValue)) {
            // Normalize PRO number to 9 digits for BOL API v2 (billofladingv2/2.0/orderentry-bol)
            const normalizedPro = conditioningService.normalizeProNumberTo9Digits(cleanValue);
            bolRequest.filter.proNbr = { startsWith: normalizedPro };
          }
          // Note: Non-numeric Q values are ignored in favor of specific search fields
          break;
          
        case 'pkupDate.Min':
          bolRequest.filter.pkupDate = bolRequest.filter.pkupDate || {};
          bolRequest.filter.pkupDate.min = BolSearchRequest.toIsoDateString(value);
          break;
          
        case 'pkupDate.Max':
          bolRequest.filter.pkupDate = bolRequest.filter.pkupDate || {};
          bolRequest.filter.pkupDate.max = BolSearchRequest.toIsoDateString(value);
          break;
          
        default:
          bolRequest.filter[key] = { equals: value };
      }
    });

    return bolRequest;
  }

  /**
   * Converts a date string (e.g. "M/D/YYYY") to "yyyy-MM-dd" format.
   */
  private static toIsoDateString(value: string): string {
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return value;
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  toJSON() {
    return {
      page: this.page,
      sortExpressions: this.sortExpressions,
      filter: this.filter
    };
  }
}